<template>
  <div class="settings">
    <div class="setting-item" @click="switchRoute('UserSecurity')">
      <div>{{ $t('security') }}</div>
      <md-icon name="arrow-right" size="sm"></md-icon>
    </div>
    <div class="setting-item" @click="popupVisible = true">
      <div>{{ $t('logout') }}</div>
      <md-icon name="arrow-right" size="sm"></md-icon>
    </div>
    <md-popup
      v-model="popupVisible"
      class="confrimPopup"
    >
      <div class="confirm-text">{{ $t('confirmTip') }}</div>
      <div class="confirm-button">
        <a role="button" class="cancel" @click="popupVisible = false">{{ $t('no') }}</a>
        <a role="button" class="confirm" @click="logout">{{ $t('yes') }}</a>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Popup, Dialog, Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        security: 'Security',
        logout: 'Logout',
        confirmTip: 'Are you sure to logout?',
        yes: 'Yes',
        no: 'No',
      },
      id: {
        security: 'Keamanan',
        logout: 'Keluar',
        confirmTip: 'Anda yakin keluar?',
        yes: 'Ya',
        no: 'Tidak',
      },
    },
  },
  components: {
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  data() {
    return {
      popupVisible: false,
    }
  },
  methods: {
    switchRoute(name) {
      this.$router.push({ name: name })
    },
    async logout() {
      await this.$store.dispatch('logout')
      if (window.bridge && window.bridge.logout) {
        window.bridge.logout()
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.settings {
  background-color: #fff;
}

.setting-item {
  padding: 20px;
  font-size: 14px;
  color: #2C2E38;
  border-bottom: 1px solid #EEEEEE;
  display: flex;
  justify-content: space-between;
}

.confrimPopup /deep/ {
  .md-popup-box {
    width: 90%;
    max-height: 20%;
    overflow-y: scroll;
    padding: 20px 20px 10px;
    background-color: #fff;
    border-radius: 4px;
  }
  .confirm-text {
    padding: 10px 0;
    text-align: center;
  }
  .confirm-button {
    display: flex;
    justify-content: space-around;
    a {
      display: block;
      padding: 10px 20px;
    }
  }
}
</style>
